import type { MiddlewareKey } from '#build/types/middleware'

export function useMiddleware() {
  const appMiddleware: MiddlewareKey[] = [
    'set-auth-middleware',
    'app-authenticated-middleware',
    'select-product-list-middleware'
  ]

  const adminMiddleware: MiddlewareKey[] = [
    'set-auth-middleware',
    'admin-authenticated-middleware'
  ]

  return {
    appMiddleware,
    adminMiddleware
  }
}
